import {initGoogleAnalytics} from './google-analytics'
import {initGoogleTagManager} from './initGoogleTagManager'
import {consentDeclined, KetchConsentPurpose} from './ketchConsent'

/**
 * Loads the tags a surface with no Ketch tag of its own is allowed to run, each behind the decline
 * that login and marketing record for us. The purposes differ per tag and are not interchangeable:
 * the Google Ads gtag is `analytics`, while the agency's container carries advertising tags and is
 * `targeted_advertising`.
 */
export function initConsentedAnalyticsTags(): void {
  if (!consentDeclined(KetchConsentPurpose.Analytics)) {
    initGoogleAnalytics()
  }

  if (!consentDeclined(KetchConsentPurpose.TargetedAdvertising)) {
    initGoogleTagManager()
  }
}
